<script setup>
import {computed} from "vue";

const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  child: {
    type: Object,
    required: true,
  },
});

const childAge = computed(() => {
  // 	props.child.birthday は "2018-04-30T15:00:00.000000Z" のような語りをしているので、先頭 10 文字だけ取得して年齢を計算する
  const birthday = props.child.birthday.slice(0, 10).replace(/-/g, '');
  const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  return Math.floor((Number(today) - Number(birthday)) / 10000);
});
</script>

<template>
  <li class="lyVerticalCnt lyMr8">
    <p class="lyW16px lyMr4"><img
      v-if="Number(child.sex) !== 0"
      :src="siteUrl+(Number(child.sex) === 1 ? 'images/faceBoy.svg' : 'images/faceBoy.svg')"
      :alt="Number(child.sex) === 1 ? '男の子' : '女の子'"
      width="16"
      height="16"
      loading="lazy"
    ></p>
    <p class="pFont12 pFontMedium">{{childAge}}才</p>
  </li>
</template>
